export default function AuthHeader() {
  let token = JSON.parse(localStorage.getItem("userDetails")).access_token;
  return { Authorization: `Bearer ${token}` };
}
